import { db } from "@/firebase/init.js";
import {
  collection,
  query,
  getDocs,
  deleteDoc,
  updateDoc,
  getDoc,
  doc,
  setDoc,
  orderBy,
} from "firebase/firestore";

const reviewModule = {
  namespaced: true,
  state: {
    reviewsList: [],
    updateReview: {},
    isLoading: true,
    isFirstLoad: true,
  },
  getters: {
    getReviews: (state) => state.reviewsList,
    isLoading: (state) => state.isLoading,
    isFirstLoad: (state) => state.isFirstLoad,
  },
  mutations: {
    // Loading
    setLoading: (state, payload) => {
      state.isLoading = payload;
    },

    // First load
    setFirstLoad: (state, payload) => {
      state.isFirstLoad = payload;
    },

    // Get All Reviews
    setReviews: (state, payload) => {
      state.reviewsList = payload;
    },

    // Add Review
    addReview: (state, payload) => {
      if (state.reviewsList.length > 0) state.reviewsList.unshift(payload);
      else state.reviewsList = [payload];
    },
    // Update Review
    updateReview: (state, payload) => {
      state.reviewsList[payload.index] = payload.review;
    },

    // get Review by id
    getReviewById: (state, payload) => {
      state.updateReview = state.reviewsList.find(
        (review) => review.review_id == payload
      );
    },

    // Delete Review
    deleteReview: (state, payload) => {
      let filtered = state.reviewsList.filter(function (value) {
        return value.review_id != payload;
      });
      state.reviewsList = filtered;
    },
  },
  actions: {
    async fetchReviews({ commit }) {
      commit("setLoading", true);
      commit("setFirstLoad", true);

      const reviewList = await getDocs(
        query(collection(db, "Reviews"), orderBy("created_date", "desc"))
      );
      let reviewArray = [];
      if (!reviewList.empty) {
        reviewList.forEach((doc) => {
          reviewArray.push({ ...doc.data(), review_id: doc.id });
        });
      } else {
        console.log("No Review found");
        reviewArray = false;
      }

      commit("setReviews", reviewArray);
      commit("setLoading", false);
      commit("setFirstLoad", false);

      return reviewArray;
    },
    // Add Review
    async addReview({ commit }, payload) {
      const documentReference = doc(collection(db, "Reviews"));
      const review = {
        ...payload,
        review_id: documentReference.id,
        created_date: new Date(),
      };
      setDoc(documentReference, review);
      commit("addReview", review);
    },
    // get Review By Id
    async getReviewById({ commit }, payload) {
      let review = await getDoc(doc(db, "Reviews", payload));

      commit("getReviewById", review.data());
      return review.data();
    },
    // Update Review
    async updateReviewById({ commit }, payload) {
      updateDoc(doc(db, "Reviews", payload.review_id), payload);
      commit("updateReview", payload);
    },
    // Delete Review
    async deleteReview({ commit }, payload) {
      deleteDoc(doc(db, "Reviews", payload));
      commit("deleteReview", payload);
    },
  },
};

export default reviewModule;
